<template>
    <div class="ai-models">
        <div class="header">
            <h3 class="title">AI Model Karşılaştırması</h3>
            <div class="actions">
                <div class="control">
                    <label>Modeli değiştir</label>
                    <a-select :value="selectedModel" @change="onChangeSelectedModel" style="width: 200px;">
                        <a-select-option value="gpt-4o">GPT‑4o</a-select-option>
                        <a-select-option value="gpt-4.1">GPT‑4.1</a-select-option>
                        <a-select-option value="gpt-4.1-mini">GPT‑4.1 Mini</a-select-option>
                        <a-select-option value="gpt-4.1-nano">GPT‑4.1 Nano</a-select-option>
                        <!--                        relations hatası düzeldiğinde açılacak-->
                        <!--                        <a-select-option value="gpt-5">GPT‑5</a-select-option>-->
                        <!--                        <a-select-option value="o4-mini">o4‑mini</a-select-option>-->

                    </a-select>
                </div>
                <a-button type="primary" @click="saveSelectedModel" :loading="saving">Kaydet</a-button>
                <div class="legend">
                    <span class="badge best">Önerilen</span>
                    <span class="badge cheap">Ekonomik</span>
                    <span class="badge realtime">Gerçek Zamanlı</span>
                </div>
            </div>
        </div>

        <div class="cards" :class="{ 'selection-active': !!selectedModel }">
            <div class="card highlight realtime model-gpt-4o" :class="{ 'is-selected': selectedModel === 'gpt-4o' }"
                 @click="onSelect('gpt-4o')">
                <div v-if="selectedModel === 'gpt-4o'" class="selected-ribbon">
                    <i class="material-icons">check_circle</i>
                    <span>Seçili</span>
                </div>
                <div class="card-head">
                    <div class="name">GPT‑4o</div>
                    <div class="right">
                        <span class="badge realtime">Gerçek Zamanlı</span>
                    </div>
                </div>
                <div class="banner">
                    <div class="banner-title">GPT‑4o</div>
                </div>
                <div class="details">
                    <div class="row"><span class="title">Intelligence</span><span class="dots">● ● ●</span></div>
                    <div class="row"><span class="title">Speed</span><span class="dots">⚡⚡⚡⚡</span></div>
                    <div class="row"><span class="title">Input</span><span class="icons"><span class="md-icon">text_fields</span><span class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>
                    <div class="row"><span class="title">Output</span><span class="icons"><span class="md-icon">text_fields</span><span class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>
                    <div class="row"><span class="title">Reasoning tokens</span><span class="icons">✖️</span></div>
                    <div class="pricing-block">
                        <div class="block-title">PRICING <span class="muted">PER 1M TOKENS</span></div>
                        <div class="p-row"><span>Input</span><span>$2.50</span></div>
                        <div class="p-row"><span>Cached Input</span><span>$1.25</span></div>
                        <div class="p-row"><span>Output</span><span>$10.00</span></div>
                    </div>
                    <div class="context-block">
                        <div class="block-title">CONTEXT</div>
                        <div class="p-row"><span>Window</span><span>128,000</span></div>
                    </div>
                </div>
            </div>

            <div class="card highlight best model-gpt-41" :class="{ 'is-selected': selectedModel === 'gpt-4.1' }"
                 @click="onSelect('gpt-4.1')">
                <div v-if="selectedModel === 'gpt-4.1'" class="selected-ribbon">
                    <i class="material-icons">check_circle</i>
                    <span>Seçili</span>
                </div>
                <div class="card-head">
                    <div class="name">GPT‑4.1</div>
                    <div class="right">
                        <span class="badge best">Önerilen</span>
                    </div>
                </div>
                <div class="banner">
                    <div class="banner-title">GPT‑4.1</div>
                </div>
                <div class="desc">Smartest non‑reasoning model</div>
                <div class="details">
                    <div class="row"><span class="title">Intelligence</span><span class="dots">● ● ● ●</span></div>
                    <div class="row"><span class="title">Speed</span><span class="dots">⚡⚡⚡</span></div>
                    <div class="row"><span class="title">Input</span><span class="icons"><span class="md-icon">text_fields</span><span
                        class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>
                    <div class="row"><span class="title">Output</span><span class="icons"><span class="md-icon">text_fields</span><span
                        class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>
                    <div class="row"><span class="title">Reasoning tokens</span><span class="icons">✖️</span></div>
                    <div class="pricing-block">
                        <div class="block-title">PRICING <span class="muted">PER 1M TOKENS</span></div>
                        <div class="p-row"><span>Input</span><span>$2.00</span></div>
                        <div class="p-row"><span>Cached Input</span><span>$0.50</span></div>
                        <div class="p-row"><span>Output</span><span>$8.00</span></div>
                    </div>
                    <div class="context-block">
                        <div class="block-title">CONTEXT</div>
                        <div class="p-row"><span>Window</span><span>1,047,576</span></div>
                    </div>
                </div>
            </div>

            <div class="card cheap model-gpt-41-mini" :class="{ 'is-selected': selectedModel === 'gpt-4.1-mini' }"
                 @click="onSelect('gpt-4.1-mini')">
                <div v-if="selectedModel === 'gpt-4.1-mini'" class="selected-ribbon">
                    <i class="material-icons">check_circle</i>
                    <span>Seçili</span>
                </div>
                <div class="card-head">
                    <div class="name">GPT‑4.1 Mini</div>
                    <div class="right">
                        <span class="badge cheap">Ekonomik</span>
                    </div>
                </div>
                <div class="banner">
                    <div class="banner-title">GPT‑4.1 mini</div>
                </div>
                <div class="desc">Smaller, faster version of GPT‑4.1</div>
                <div class="details">
                    <div class="row"><span class="title">Intelligence</span><span class="dots">● ● ●</span></div>
                    <div class="row"><span class="title">Speed</span><span class="dots">⚡⚡⚡⚡⚡</span></div>
                    <div class="row"><span class="title">Input</span><span class="icons"><span class="md-icon">text_fields</span><span
                        class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>
                    <div class="row"><span class="title">Output</span><span class="icons"><span class="md-icon">text_fields</span><span
                        class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>
                    <div class="row"><span class="title">Reasoning tokens</span><span class="icons">✖️</span></div>
                    <div class="pricing-block">
                        <div class="block-title">PRICING <span class="muted">PER 1M TOKENS</span></div>
                        <div class="p-row"><span>Input</span><span>$0.40</span></div>
                        <div class="p-row"><span>Cached Input</span><span>$0.10</span></div>
                        <div class="p-row"><span>Output</span><span>$1.60</span></div>
                    </div>
                    <div class="context-block">
                        <div class="block-title">CONTEXT</div>
                        <div class="p-row"><span>Window</span><span>1,047,576</span></div>
                    </div>
                </div>
            </div>

            <div class="card nano model-gpt-41-nano" :class="{ 'is-selected': selectedModel === 'gpt-4.1-nano' }"
                 @click="onSelect('gpt-4.1-nano')">
                <div v-if="selectedModel === 'gpt-4.1-nano'" class="selected-ribbon">
                    <i class="material-icons">check_circle</i>
                    <span>Seçili</span>
                </div>
                <div class="card-head">
                    <div class="name">GPT‑4.1 Nano</div>
                    <div class="right">
                        <span class="badge nano">Ultra Hafif</span>
                    </div>
                </div>
                <div class="banner">
                    <div class="banner-title">GPT‑4.1 nano</div>
                </div>
                <div class="desc">Fastest, most cost‑efficient version of GPT‑4.1</div>
                <div class="details">
                    <div class="row"><span class="title">Intelligence</span><span class="dots">● ●</span></div>
                    <div class="row"><span class="title">Speed</span><span class="dots">⚡⚡⚡⚡⚡</span></div>
                    <div class="row"><span class="title">Input</span><span class="icons"><span class="md-icon">text_fields</span><span
                        class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>
                    <div class="row"><span class="title">Output</span><span class="icons"><span class="md-icon">text_fields</span><span
                        class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>
                    <div class="row"><span class="title">Reasoning tokens</span><span class="icons">✖️</span></div>
                    <div class="pricing-block">
                        <div class="block-title">PRICING <span class="muted">PER 1M TOKENS</span></div>
                        <div class="p-row"><span>Input</span><span>$0.10</span></div>
                        <div class="p-row"><span>Cached Input</span><span>$0.03</span></div>
                        <div class="p-row"><span>Output</span><span>$0.40</span></div>
                    </div>
                    <div class="context-block">
                        <div class="block-title">CONTEXT</div>
                        <div class="p-row"><span>Window</span><span>1,047,576</span></div>
                    </div>
                </div>
            </div>

            <!--            <div class="card model-gpt-5" :class="{ 'is-selected': selectedModel === 'gpt-5' }"-->
            <!--                 @click="onSelect('gpt-5')">-->
            <!--                <div v-if="selectedModel === 'gpt-5'" class="selected-ribbon">-->
            <!--                    <i class="material-icons">check_circle</i>-->
            <!--                    <span>Seçili</span>-->
            <!--                </div>-->
            <!--                <div class="card-head">-->
            <!--                    <div class="name">GPT‑5</div>-->
            <!--                    <div class="right">-->
            <!--                        <span class="badge best">Yeni Nesil</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="banner">-->
            <!--                    <div class="banner-title">GPT‑5</div>-->
            <!--                </div>-->
            <!--                <div class="desc">The best model for coding and agentic tasks across domains</div>-->
            <!--                <div class="details">-->
            <!--                    <div class="row"><span class="title">Reasoning</span><span class="dots">● ● ● ● ●</span></div>-->
            <!--                    <div class="row"><span class="title">Speed</span><span class="dots">⚡⚡⚡</span></div>-->
            <!--                    <div class="row"><span class="title">Input</span><span class="icons"><span class="md-icon">text_fields</span><span-->
            <!--                        class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>-->
            <!--                    <div class="row"><span class="title">Output</span><span class="icons"><span class="md-icon">text_fields</span><span-->
            <!--                        class="md-icon">image</span><span class="md-icon disabled">not_interested</span></span></div>-->
            <!--                    <div class="row"><span class="title">Reasoning tokens</span><span class="icons">✔️</span></div>-->
            <!--                    <div class="pricing-block">-->
            <!--                        <div class="block-title">PRICING <span class="muted">PER 1M TOKENS</span></div>-->
            <!--                        <div class="p-row"><span>Input</span><span>$1.25</span></div>-->
            <!--                        <div class="p-row"><span>Cached Input</span><span>$0.13</span></div>-->
            <!--                        <div class="p-row"><span>Output</span><span>$10.00</span></div>-->
            <!--                    </div>-->
            <!--                    <div class="context-block">-->
            <!--                        <div class="block-title">CONTEXT</div>-->
            <!--                        <div class="p-row"><span>Window</span><span>400,000</span></div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->

            <!--            <div class="card" :class="{ 'is-selected': selectedModel === 'o4-mini' }" @click="onSelect('o4-mini')">-->
            <!--                <div v-if="selectedModel === 'o4-mini'" class="selected-ribbon">-->
            <!--                    <i class="material-icons">check_circle</i>-->
            <!--                    <span>Seçili</span>-->
            <!--                </div>-->
            <!--                <div class="card-head">-->
            <!--                    <div class="name">o4‑mini</div>-->
            <!--                    <div class="right">-->
            <!--                        <span class="badge realtime">Reasoning</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="banner">-->
            <!--                    <div class="banner-title">o4‑mini</div>-->
            <!--                </div>-->
            <!--                <div class="desc">Fast, cost‑efficient reasoning model, succeeded by GPT‑5 mini</div>-->
            <!--                <div class="details">-->
            <!--                    <div class="row"><span class="title">Reasoning</span><span class="dots">● ● ● ●</span></div>-->
            <!--                    <div class="row"><span class="title">Speed</span><span class="dots">⚡⚡⚡</span></div>-->
            <!--                    <div class="row"><span class="title">Input</span><span class="icons"><span class="md-icon">psychology</span><span-->
            <!--                        class="md-icon">text_fields</span><span class="md-icon">image</span><span class="md-icon">hearing_disabled</span></span>-->
            <!--                    </div>-->
            <!--                    <div class="row"><span class="title">Output</span><span class="icons"><span class="md-icon">psychology</span><span-->
            <!--                        class="md-icon">text_fields</span><span class="md-icon">image</span><span class="md-icon">hearing_disabled</span></span>-->
            <!--                    </div>-->
            <!--                    <div class="row"><span class="title">Reasoning tokens</span><span class="icons">✔️</span></div>-->
            <!--                    <div class="pricing-block">-->
            <!--                        <div class="block-title">PRICING <span class="muted">PER 1M TOKENS</span></div>-->
            <!--                        <div class="p-row"><span>Input</span><span>$1.10</span></div>-->
            <!--                        <div class="p-row"><span>Cached Input</span><span>$0.28</span></div>-->
            <!--                        <div class="p-row"><span>Output</span><span>$4.40</span></div>-->
            <!--                    </div>-->
            <!--                    <div class="context-block">-->
            <!--                        <div class="block-title">CONTEXT</div>-->
            <!--                        <div class="p-row"><span>Window</span><span>200,000</span></div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->


        </div>

        <div class="disclaimer">Fiyatlar göreceli olarak ifade edilmiştir; plan/bölge ve sürümlere göre değişir.</div>
    </div>
</template>
<script>
import { CHATBOT_API } from "../../../../api/chatbotv2";

export default {
    name: "AIModels",
    props: {
        storyId: String,
    },
    data() {
        return {
            selectedModel: "gpt-4o",
            saving: false,
            apiModelMap: {
                "gpt-4o": "gpt-4o",
                "gpt-4.1": "gpt-4.1",
                "gpt-4.1-mini": "gpt-4.1-mini",
                "gpt-4.1-nano": "gpt-4.1-nano",
                "gpt-5": "gpt-5",
                "o4-mini": "o4-mini",
            },
        };
    },
    methods: {
        onChangeSelectedModel(val) {
            this.selectedModel = val;
        },
        onSelect(model) {
            this.selectedModel = model;
        },
        normalizeModelName(model) {
            if (model === "gpt-5-fast") return "gpt-5";
            return model;
        },
        initSelectedModel() {
            try {
                const cacheKey = `ai.selectedModel.${this.storyId}`;
                const cached = typeof window !== "undefined" ? window.localStorage.getItem(cacheKey) : null;
                if (cached) {
                    this.selectedModel = this.normalizeModelName(cached);
                    return;
                }

                const story = (this.$store && this.$store.state && this.$store.state.CB && Array.isArray(this.$store.state.CB.stories))
                    ? this.$store.state.CB.stories.find((s) => s._id === this.storyId)
                    : null;
                const current = story && story.ai && story.ai.model ? story.ai.model : null;
                this.selectedModel = this.normalizeModelName(current) || "gpt-4o";
            } catch (e) {
                this.selectedModel = "gpt-4o";
            }
        },
        async saveSelectedModel() {
            try {
                this.saving = true;
                await CHATBOT_API.updateStorySingleKey({
                    id: this.storyId,
                    key: "ai.model",
                    value: this.apiModelMap[this.selectedModel] || this.selectedModel,
                });
                try {
                    const stories = (this.$store && this.$store.state && this.$store.state.CB && Array.isArray(this.$store.state.CB.stories))
                        ? this.$store.state.CB.stories
                        : [];
                    const idx = stories.findIndex((s) => s._id === this.storyId);
                    if (idx !== -1) {
                        const currentAi = stories[idx].ai || {};
                        this.$set(stories[idx], "ai", Object.assign({}, currentAi, { model: this.apiModelMap[this.selectedModel] || this.selectedModel }));
                    }
                } catch (e) {
                }

                try {
                    const cacheKey = `ai.selectedModel.${this.storyId}`;
                    if (typeof window !== "undefined") {
                        window.localStorage.setItem(cacheKey, this.apiModelMap[this.selectedModel] || this.selectedModel);
                    }
                } catch (e) {
                }
                this.$message.success("AI modeli güncellendi");
            } catch (e) {
                this.$message.error("AI modeli güncellenemedi");
            } finally {
                this.saving = false;
            }
        },
    },
    mounted() {
        if (typeof CHATBOT_API.getStoryById === "function") {
            CHATBOT_API.getStoryById(this.storyId)
                .then((res) => {
                    const story = (res && res.data) ? res.data : null;
                    const current = story && story.ai && story.ai.model ? story.ai.model : null;
                    const cacheKey = `ai.selectedModel.${this.storyId}`;
                    const cached = typeof window !== "undefined" ? window.localStorage.getItem(cacheKey) : null;
                    this.selectedModel = this.normalizeModelName(current) || this.normalizeModelName(cached) || this.selectedModel;
                })
                .catch(() => {
                    this.initSelectedModel();
                });
        } else {
            this.initSelectedModel();
        }
    },
    watch: {
        storyId() {
            if (typeof CHATBOT_API.getStoryById === "function") {
                CHATBOT_API.getStoryById(this.storyId)
                    .then((res) => {
                        const story = (res && res.data) ? res.data : null;
                        const current = story && story.ai && story.ai.model ? story.ai.model : null;
                        const cacheKey = `ai.selectedModel.${this.storyId}`;
                        const cached = typeof window !== "undefined" ? window.localStorage.getItem(cacheKey) : null;
                        this.selectedModel = this.normalizeModelName(current) || this.normalizeModelName(cached) || "gpt-4o";
                    })
                    .catch(() => {
                        this.initSelectedModel();
                    });
            } else {
                this.initSelectedModel();
            }
        },
    },
};
</script>
<style scoped lang="scss">
.ai-models {
    padding: 20px;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        .title {
            font-size: 18px;
            font-weight: 600;
            margin: 0;
        }

        .actions {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .legend {
            display: flex;
            gap: 6px;
        }

        .control {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .control label {
            font-size: 13px;
            color: #555;
        }
    }

    .cards {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 16px;

        .card {
            background: #fff;
            border: 1px solid #e8e8e8;
            border-radius: 12px;
            padding: 16px;
            transition: transform .2s ease, box-shadow .2s ease;

            &:hover {
                transform: translateY(-3px);
                box-shadow: 0 8px 20px rgba(0, 0, 0, .08);
            }

            .card-head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 6px;
            }

            .name {
                font-size: 16px;
                font-weight: 700;
            }

            .desc {
                color: #555;
                margin-bottom: 8px;
            }

            .actions-row {
                display: flex;
                gap: 10px;
                margin: 12px 0;
            }

            .btn {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                height: 36px;
                padding: 0 14px;
                border-radius: 999px;
                border: 1px solid #111;
                background: #111;
                color: #fff;
                text-decoration: none;
                font-size: 13px;
            }

            .btn.ghost {
                background: #fff;
                color: #111;
                border-color: #e6e6e6;
            }

            .features {
                list-style: none;
                padding-left: 0;
                margin: 0 0 10px 0;
            }

            .features li {
                display: flex;
                align-items: center;
                gap: 6px;
                padding: 4px 0;
                color: #333;
            }

            .features .material-icons {
                font-size: 18px;
                color: #666;
            }

            .md-icon {
                font-family: 'Material Icons';
                font-style: normal;
                font-weight: normal;
                font-size: 18px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #333;
                margin-right: 6px;
            }

            .md-icon.disabled {
                color: #bfbfbf;
                text-decoration: line-through;
            }

            .price {
                background: #fafafa;
                border: 1px solid #eee;
                border-radius: 8px;
                padding: 10px;
                display: grid;
                grid-template-columns: 1fr;
                gap: 4px;

                .label {
                    font-weight: 600;
                    color: #444;
                }

                .value {
                    font-size: 13px;
                    color: #555;
                    background: #fff;
                    border: 1px solid #f0f0f0;
                    border-radius: 6px;
                    padding: 8px;
                    line-height: 1.35;
                    word-break: break-word;
                }
            }

            .details {
                margin-top: 12px;
                border-top: 1px dashed #eee;
                padding-top: 10px;
                padding: 20px
            }

            .details .row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 6px 0;
                font-size: 13px;
                color: #333;
            }

            .details .block-title {
                margin-top: 12px;
                font-weight: 700;
                font-size: 12px;
                color: #555;
                display: flex;
                align-items: center;
                gap: 6px;
            }

            .details .block-title .muted {
                font-weight: 400;
                color: #999;
            }

            .details .p-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 6px 0;
                font-size: 13px;
            }

            .usecases {
                margin-top: 8px;
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
            }

            .chip {
                background: #f0f5ff;
                border: 1px solid #d6e4ff;
                color: #1d39c4;
                padding: 4px 8px;
                border-radius: 999px;
                font-size: 12px;
            }
        }

        .card.is-selected {
            border-color: #1890ff;
            box-shadow: 0 8px 24px rgba(24, 144, 255, 0.15);
            position: relative;
            background: linear-gradient(180deg, #ffffff 0%, #f5fbff 100%);
        }

        /* top colorful banner */
        .card .banner {
            height: 120px;
            border-radius: 10px;
            margin: 8px 0 12px;
            background: linear-gradient(135deg, #e5f0ff 0%, #fff 60%);
            border: 1px solid #f0f0f0;
            position: relative;
            overflow: hidden;
        }

        .card .banner .banner-title {
            position: absolute;
            left: 16px;
            bottom: 14px;
            color: #fff;
            font-weight: 800;
            font-size: 22px;
            line-height: 1;
            text-shadow: 0 2px 6px rgba(0, 0, 0, .35);
        }

        .model-gpt-5 .banner {
            background: radial-gradient(60% 90% at 20% 20%, #ffb2c8 0%, #ffc9a9 35%, #ffd9f2 60%, #f1e5ff 100%);
        }

        .model-gpt-4o .banner {
            background: radial-gradient(60% 90% at 20% 20%, #b2e5ff 0%, #a9d6ff 35%, #d9f2ff 60%, #e5f6ff 100%);
        }

        .model-gpt-41 .banner {
            background: radial-gradient(60% 90% at 20% 20%, #7dd3fc 0%, #60a5fa 35%, #93c5fd 60%, #bfdbfe 100%);
        }

        .model-gpt-41-mini .banner {
            background: radial-gradient(60% 90% at 20% 20%, #a7f3d0 0%, #6ee7b7 35%, #99f6e4 60%, #d1fae5 100%);
        }

        .model-gpt-41-nano .banner {
            background: radial-gradient(60% 90% at 20% 20%, #e9d5ff 0%, #c4b5fd 35%, #ddd6fe 60%, #ede9fe 100%);
        }

        .card .selected-ribbon {
            position: absolute;
            top: -10px;
            left: -10px;
            background: #1890ff;
            color: #fff;
            display: flex;
            align-items: center;
            gap: 4px;
            padding: 4px 8px;
            border-radius: 999px;
            box-shadow: 0 6px 16px rgba(24, 144, 255, .25);
            font-size: 12px;
            z-index: 1;
        }

        .card .selected-tag {
            border: 1px solid #91d5ff;
            background: #e6f7ff;
            color: #0050b3;
            border-radius: 999px;
            padding: 2px 8px;
            font-size: 12px;
            margin-left: 6px;
        }
    }

    .badge {
        padding: 2px 8px;
        border-radius: 999px;
        font-size: 12px;
        border: 1px solid transparent;
    }

    .badge.best {
        background: #f6ffed;
        border-color: #b7eb8f;
        color: #135200;
    }

    .badge.cheap {
        background: #fff7e6;
        border-color: #ffd591;
        color: #874d00;
    }

    .badge.realtime {
        background: #e6f7ff;
        border-color: #91d5ff;
        color: #0050b3;
    }

    .badge.nano {
        background: #f9f0ff;
        border-color: #d3adf7;
        color: #391085;
    }

    .card.best {
        border-color: #b7eb8f;
    }

    .card.cheap {
        border-color: #ffd591;
    }

    .card.realtime {
        border-color: #91d5ff;
    }

    .card.nano {
        border-color: #d3adf7;
    }

    .tips {
        margin-top: 15px;
        display: grid;
        gap: 10px;

        .tip {
            background: #f6f9ff;
            border: 1px solid #dbe7ff;
            border-radius: 6px;
            padding: 10px 12px;
        }
    }

    .disclaimer {
        margin-top: 10px;
        font-size: 12px;
        color: #888;
    }
}
</style>


